import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Hero } from './Hero';
import { FeaturedProducts } from './FeaturedProducts';
import { Categories } from './Categories';
import { Gen3Features } from './Gen3Features';
/**
 * Home page orchestrator. Composes its own page-specific sections; nothing
 * inside `./` is shared with other pages.
 */
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-732">
      <Header data-id="element-733" />
      <main className="flex-grow" data-id="element-734">
        <Hero data-id="element-735" />
        <FeaturedProducts data-id="element-736" />
        <Categories data-id="element-737" />
        <Gen3Features data-id="element-738" />
      </main>
      <Footer data-id="element-739" />
    </div>;
}